import { render, staticRenderFns } from "./EditorialsList.vue?vue&type=template&id=158ce3bc&"
import script from "./EditorialsList.vue?vue&type=script&lang=js&"
export * from "./EditorialsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports